// @flow
import React from 'react'
import PropTypes from 'prop-types'
import { compose, setPropTypes, withProps } from 'recompose'
import SearchResultsItemsBefore from '../../ui/views/search-results-items-before'
import SearchResultsItemsLive from '../../ui/views/search-results-items-live'
import SearchResultsItemsClose from '../../ui/views/search-results-items-close'
import withAuctionCountdown from '../auction/withAuctionCountdown'
import withEntity from '../../context/with-entity'
import { AUCTION_STATE } from '../auction/constants'

const withPropTypes = setPropTypes({
  entity: PropTypes.object.isRequired
})

const withConversionProps = withProps(props => {
  if (props.entity)
    return {
      item: props.entity,
      auction: props.entity.auction
    }
})

const SearchResultsItemsEnhancer = compose(
  withEntity,
  withPropTypes,
  withConversionProps,
  withAuctionCountdown
)

const SearchResultsItems = props => {
  const { auction } = props
  const { PENDING, LIVE, CLOSED } = AUCTION_STATE
  return (
    (auction.state === PENDING && <SearchResultsItemsBefore {...props} />) ||
    (auction.state === LIVE && <SearchResultsItemsLive {...props} />) ||
    (auction.state === CLOSED && <SearchResultsItemsClose {...props} />)
  )
}

export default SearchResultsItemsEnhancer(SearchResultsItems)



// WEBPACK FOOTER //
// ./src/services/search-results/SearchResultsItems.js